import { createAction } from 'redux-act';

import * as logs from '../../core/logs';

export const fetchLogs = createAction(
  'get all logs',
);

export const fetchLogsSuccess = createAction(
  'get all logs success',
  (allLogs) => allLogs
);

export const fetchLogsFail = createAction(
  'get all logs fail',
  (error) => error
);

export const reducer = {
  [fetchLogs]: (state, payload) =>
    logs.fetchLogs(state, payload),
  [fetchLogsSuccess]: (state, payload) =>
    logs.fetchLogsSuccess(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/logs.module.js
 **/